import {FC} from 'react'
import {useLang} from './Metronici18n'
import {IntlProvider} from 'react-intl'
import '@formatjs/intl-relativetimeformat/polyfill'
import '@formatjs/intl-relativetimeformat/locale-data/en'
import '@formatjs/intl-relativetimeformat/locale-data/ar'

import {WithChildren} from '../helpers'

import generalMessages from './messages/general.json'
import userMessages from './messages/user.json'
import chatMessages from './messages/chat.json'
import apiAccessRequest from './messages/api_access_request.json'

const allMessages = {
  ...generalMessages,
  ...userMessages,
  ...chatMessages,
  ...apiAccessRequest,
}

const flattenTranslations = (nestedTranslations: any, locale: string, parentKey: string = '', result: { [key: string]: string } = {}) => {
  for (const key in nestedTranslations) {
    if (nestedTranslations.hasOwnProperty(key)) {
      const value = nestedTranslations[key];
      const newKey = parentKey ? `${parentKey}.${key}` : key;

      if (typeof value === 'object' && value[locale]) {
        result[newKey] = value[locale];
      } else if (typeof value === 'object' && !value[locale]) {
        flattenTranslations(value, locale, newKey, result);
      }
    }
  }
  return result;
};

const I18nProvider: FC<WithChildren> = ({children}) => {
  const locale = useLang()
  const messages = flattenTranslations(allMessages, locale);
  
  return (
    <IntlProvider locale={locale} messages={messages}>
      {children}
    </IntlProvider>
  )
}

export {I18nProvider}
